<template>
  <!-- <pre v-if="responseData">{{ responseData.cctv_by_states }}</pre> -->
  <Background v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/CCTV DI SELURUH MALAYSIA.png"
        alt="CCTV DI SELURUH MALAYSIA"
        class="pbt-image"
      >
   
      <div class="line-under-image" />
    </div>
  
    <div class="carousel-wrapper">
      <div class="carousel">
        <VSlickCarousel v-bind="settings">
          <div class="map-container">
            <div class="state-column left">
              <div
                v-for="(cctvData, state) in leftStatesData"
                :key="state"
                class="state-box"
              >
                <div class="state-content">
                  <h2>{{ state }}</h2>
                  <p>{{ cctvData }}</p>
                </div>
              </div>
            </div>
      
            <div class="map-image-container">
              <img
                src="@/assets/map/Map.png"
                alt="Image 1"
                class="carousel-image"
              >
            </div>

            <div class="state-column right">
              <div
                v-for="(cctvData, state) in rightStatesData"
                :key="state"
                class="state-box"
              >
                <div class="state-content">
                  <h2>{{ state }}</h2>
                  <p>{{ cctvData }}</p>
                </div>
              </div>
            </div>
          </div>
          
          <div class="map-container">
            <div class="map-image-container">
              <img
                src="@/assets/map/Map2.png"
                alt="Image 1"
                class="carousel-image"
              >
            </div>
            <div class="state-column right">
              <div
                v-for="(cctvData, state) in sabahStatesData"
                :key="state"
                class="state-box"
              >
                <div class="state-content">
                  <h2>{{ state }}</h2>
                  <p>{{ cctvData }}</p>
                </div>
              </div>
            </div>
          </div>
        </VSlickCarousel>
      </div>
    </div>
  </Background>
  <UtamaMenu />
</template>

<script setup>
import { useHttpService } from "@/httpService"
import { VSlickCarousel } from 'v-slick-carousel'
import 'v-slick-carousel/style.css'
import { onMounted, ref } from 'vue'

definePage({
  alias: "/pages/pages/inspektorat/ahli-pbt",
  meta: {
    layout: "blank",
    public: true,
  },
})

const { loading, error, httpDelete, httpPostPut, httpGet, httpPost,
  numberWithCommas,
  formatToMillion, calculatePercentage } = useHttpService()

const responseData = ref(null)
const leftStatesData = ref({})
const rightStatesData = ref({})
const sabahStatesData = ref({})





const settings = {
  slidesToShow: 1,
  slidesToScroll: 1,
}

function getCctvdata(stateName) {

  if(responseData.value){
    const stateData = responseData.value.cctv_by_states.find(item => item.state == stateName)  
  
    return stateData ? stateData.jumlah : '0'
  }
  
  return 'no data'
}


async function  loadDataFromApi(){
  try {
    const response = await httpGet('kejuruteraan-awam/cctv')

    responseData.value = response
    
    leftStatesData.value = {
      PERLIS: getCctvdata('Perlis'),
      KEDAH: getCctvdata('Kedah'),
      "P.PINANG": getCctvdata('Pulau Pinang'),
      PERAK: getCctvdata('Perak'),
      SELANGOR: getCctvdata('Selangor'),
      "K.LUMPUR": getCctvdata('W.p Kuala Lumpur'),
      PUTRAJAYA: getCctvdata('W.p Putrajaya'),
    }

    rightStatesData.value = {
      "N.SEMBILAN": getCctvdata('Negeri Sembilan'),
      MELAKA: getCctvdata('Melaka'),
      KELANTAN: getCctvdata('Kelantan'),
      TERENGGANU: getCctvdata('Terengganu'),
      PAHANG: getCctvdata('Pahang'),
      JOHOR: getCctvdata('Johor'),
    }

    sabahStatesData.value = {
      SABAH: getCctvdata('Wilayah Sabah'),
      SARAWAK: getCctvdata('Wilayah Sarawak'),
      LABUAN: getCctvdata('W.p Labuan'),
    }
  } catch (err) {
    console.error('loadDataFromApi CCTV failed:', err)
  }

 
}
onMounted(() => {
  loadDataFromApi()
})
</script>

<style scoped>
.carousel-wrapper {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 65%); 
  inline-size: 100%;
  max-inline-size: 1200px;
}

h2 {
  display: block;
  color: #150069;
  font-size: 30px;
  font-weight: 600;
  font-weight: bold;
  margin-block-end: 20px;
  text-align: start;
  
}


.carousel {
  margin-block: 0;
  margin-inline: auto;
  max-inline-size: 95%; 
  
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.map-image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  inline-size: 70%;
  margin-block-start: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%; 
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%; 
  margin-block-start: 10px;
}

.carousel-image {
  block-size: auto;
  inline-size: 100%;
}

.map-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}


.state-column {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-block-start: 30px;
}

.state-column.left {
  align-items: flex-end; 
  inset-inline-start: 0;
}

.state-column.right {
  align-items: flex-start;
  inset-inline-end: 0;
}

.map-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}


.state-box {
  padding: 15px; 
  border-radius: 7px;
  background: linear-gradient(95.35deg, #2900cf);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 10%);
  color: white;
  min-inline-size: 180px;
  text-align: center;
}


.state-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 1.5rem; 
}


.state-content h2 {
  flex-basis: 70%;
  margin: 0;
  color: white;
  font-size: 1.2rem;
  text-align: start;
}


.state-content p {
  flex-basis: 30%;
  margin: 0;
  color: white;
  font-size: 1rem;
  text-align: end; 
}



@media (max-width: 1024px) {
  .carousel-wrapper {
    padding: 15px;
  }

  .map-image-container {
    inline-size: 80%; 
  }

  .state-column {
    margin-top: 20px;
    gap: 10px;
  }

  .state-box {
    min-inline-size: 150px;
    padding: 10px;
  }

  .state-content h2 {
    font-size: 1.1rem;
  }

  .state-content p {
    font-size: 0.9rem;
  }
}


@media (max-width: 768px) {
  .carousel-wrapper {
    padding: 10px;
    max-inline-size: 100%;
  }

  .map-image-container {
    inline-size: 90%; 
  }

  .state-column {
    margin-top: 15px;
    gap: 8px;
  }

  .state-box {
    min-inline-size: 140px;
    padding: 8px;
  }

  .state-content {
    flex-direction: column; 
  }

  .state-content h2 {
    font-size: 1rem;
    text-align: center;
  }

  .state-content p {
    font-size: 0.85rem;
    text-align: center;
  }
}


@media (max-width: 480px) {
  .carousel-wrapper {
    padding: 8px;
  }

  .map-image-container {
    inline-size: 100%; 
  }

  .state-column {
    margin-top: 10px;
    gap: 5px;
  }

  .state-box {
    min-inline-size: 120px;
    padding: 6px;
  }

  .state-content h2 {
    font-size: 0.9rem;
  }

  .state-content p {
    font-size: 0.8rem;
  }
}
</style>
